import { render, staticRenderFns } from "./FormK.vue?vue&type=template&id=5b002ca9&scoped=true"
import script from "./FormK.vue?vue&type=script&lang=ts"
export * from "./FormK.vue?vue&type=script&lang=ts"
import style0 from "@/styles/_pdf.scss?vue&type=style&index=0&id=5b002ca9&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b002ca9",
  null
  
)

export default component.exports